import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from '@lib/components/landing-page/landing-page.component';
import { UnauthorizedComponent } from '@lib/components/unauthorized/unauthorized.component';
import { AdminFicheComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-fiche/admin-fiche.component';
import { AdminPageComponent } from 'projects/fiche-conseil-backoffice/src/app/components/admin-page/admin-page.component';
import { authBackOfficeGuard } from 'projects/fiche-conseil-backoffice/src/app/guards/auth.guard';
import { FicheDashboardComponent } from 'src/app/components/admin-page/admin-fiche/fiche-dashboard/fiche-dashboard.component';
import { FicheDetailsComponent } from 'src/app/components/admin-page/admin-fiche/fiche-details/fiche-details.component';
import { FichiersAllocationComponent } from 'src/app/components/admin-page/admin-fichiers-allocation/fichiers-allocation.component';
import { InitGuard } from 'src/app/guards/auth.guard';

const routes: Routes = [
  {
    path: 'admin',
    title: 'Administration',
    component: AdminPageComponent,
    canActivate: [authBackOfficeGuard],
    children: [
      {
        path: 'fiches',
        title: 'Administration fiches conseil',
        component: AdminFicheComponent,
        canActivate: [authBackOfficeGuard],
        children: [
          {
            path: 'details/:coaId',
            title: 'Details fiche conseil',
            component: FicheDetailsComponent,
            canActivate: [authBackOfficeGuard],
          },
          {
            path: 'liste',
            title: 'Liste fiches conseil',
            component: FicheDashboardComponent,
            canActivate: [authBackOfficeGuard],
          },
          { path: '**', redirectTo: 'liste' },
        ],
      },
      {
        path: 'fichiers-allocation',
        title: 'Fichiers allocation',
        component: FichiersAllocationComponent,
        canActivate: [authBackOfficeGuard],
      },
      { path: '**', redirectTo: 'fiches' },
    ],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'init', component: LandingPageComponent, canActivate: [InitGuard] },
  { path: '**', redirectTo: 'admin' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
